import React from "react";
import { Grid } from "@mui/material";
import FileItem from "./FileItem";

interface FileListProps {
  files: File[];
  onRemoveFile: (fileName: string) => void;
  onOpenFile: (file: File) => void;
}

const FileList: React.FC<FileListProps> = ({
  files,
  onRemoveFile,
  onOpenFile,
}) => {
  return (
    <Grid container justifyContent="center" spacing={2} padding={2}>
      {files.map((file) => (
        <Grid
          item
          key={file.name}
          sx={{
            display: "flex",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <FileItem file={file} onRemove={onRemoveFile} onOpen={onOpenFile} />
        </Grid>
      ))}
    </Grid>
  );
};

export default FileList;
